<template>
  <section id="oportunidad" class="opportunity-section">
    <div class="container">
      <div class="opp">
        <div class="big" aria-hidden="true">{{ displayCount }}</div>
        <div>
          <h2 class="section-title">El 1 de enero de 2027 cambia el mercado</h2>
          <p class="lede">
            KFF estima que 1.4 millones de inmigrantes con presencia legal perderían su cobertura médica
            por la ley fiscal de 2025. Desde 2027 pierden el subsidio de ACA:
          </p>
          <div class="groups">
            <span v-for="(g, i) in groups" :key="i">{{ g }}</span>
          </div>
          <p class="body">
            Pueden comprar seguro a precio completo, pero para la mayoría no es pagable.
            Hispano Medical Plan les da médico de cabecera, prevención y descuentos por una mensualidad fija.
          </p>
          <p class="src">Fuentes: KFF y HealthInsurance.org (2026).</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/**
 * Bloque oportunidad 1.4M (mockup Programa 2027).
 */
export default {
  name: 'OpportunitySection',
  data() {
    return {
      displayCount: '1.4M',
      groups: [
        'Personas con TPS',
        'Parole humanitario',
        'Asilados y refugiados sin green card',
        'Visas de trabajo'
      ],
      observer: null
    }
  },
  mounted() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
    const el = this.$el.querySelector('.big')
    if (!el) return
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0] || !entries[0].isIntersecting) return
        this.observer.disconnect()
        this.animateCount()
      },
      { threshold: 0.5 }
    )
    this.observer.observe(el)
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect()
  },
  methods: {
    animateCount() {
      const t0 = performance.now()
      const step = (t) => {
        const k = Math.min(1, (t - t0) / 1200)
        const v = 1.4 * (1 - Math.pow(1 - k, 3))
        this.displayCount = `${v.toFixed(1)}M`
        if (k < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.opportunity-section {
  padding: 80px 0;
  background: $landing-bg-white;
}

.opp {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 56px;
  align-items: center;
}

.big {
  font-weight: 900;
  font-size: clamp(5rem, 14vw, 11rem);
  line-height: 0.85;
  color: $landing-accent-text;
  letter-spacing: -0.04em;
}

.section-title {
  font-size: clamp(1.6rem, 3vw, 2.25rem);
  font-weight: 800;
  color: $landing-primary-color;
  margin: 0;
}

.lede {
  margin-top: 16px;
  font-size: 1.1rem;
  color: $landing-text-medium;
  line-height: 1.55;
}

.groups {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 20px 0;
}

.groups span {
  background: $landing-bg-light;
  border: 1px solid $landing-border-light;
  border-radius: 10px;
  padding: 10px 14px;
  font-weight: 600;
  color: $landing-text-dark;
  font-size: 0.95rem;
}

.body {
  color: $landing-text-medium;
  line-height: 1.55;
  margin: 0;
}

.src {
  margin-top: 14px;
  margin-bottom: 0;
  font-size: 0.9rem;
  color: $landing-text-light;
}

@media (max-width: 820px) {
  .opportunity-section {
    padding: 48px 0;
  }

  .opp {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}
</style>
